import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from '@angular/core';
import { ViewService } from 'tangoe-design-system';

export interface StickyObserverEvent {
  elt: HTMLElement;
  scrollable: HTMLElement;
  property: 'top' | 'bottom' | 'left' | 'right';
  stuck: boolean;
}

@Directive({
  selector: '[ts-sticky-observer]'
})
export class StickyObserverDirective implements AfterViewInit, OnDestroy {
  @Input('ts-sticky-observer') scrollable_element?: HTMLElement | null = null;
  @Input('sticky-property') property: StickyObserverEvent['property'] = 'top';
  @Output('stick') stick: EventEmitter<StickyObserverEvent> = new EventEmitter();
  private observer: IntersectionObserver | undefined = undefined;

  constructor(private elt: ElementRef, private view_svc: ViewService) {}

  ngAfterViewInit(): void {
    if (!this.scrollable_element) this.scrollable_element = this.view_svc.scrollableElement();
    if (!this.elt.nativeElement || !this.scrollable_element) return;

    const styles: CSSStyleDeclaration | undefined = this.view_svc.getComputedStyles(
      this.elt.nativeElement
    );

    if (!styles || styles[this.property] === 'auto') return;

    this.observer = this.view_svc.createIntersectionObserver(
      (entries: IntersectionObserverEntry[]) => {
        this.stick.emit({
          elt: this.elt.nativeElement,
          scrollable: this.scrollable_element!,
          property: this.property,
          stuck: entries[0].intersectionRatio < 1
        });
      },
      {
        root: this.scrollable_element,
        rootMargin: ['top', 'right', 'bottom', 'left'].reduce((acc: string, curr: string) => {
          if (acc) acc += ' ';
          return (acc += `${this.property == curr ? parseInt(styles[curr]) - 1 : '0'}px `);
        }, ''),
        threshold: 1.0
      }
    );

    this.observer?.observe(this.elt.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
